import React, { FunctionComponent } from 'react';
import SpecificationsDetailList from './specificationsDetailList/SpecificationsDetailList';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';
import SpecificationsAndFeaturesLoader from '../../../../presentational/loaders/SpecificationsAndFeaturesLoader';
import { GetCarSpecifications_carSpecifications } from '../../../../../graphql/queries/__generated__/GetCarSpecifications';
import specDataExtractor from '../../../../../../gqlCommon/service/specDataExtractor';
import { SpecificationsTypes } from '../../../../../../gqlCommon/enum/SpecificationsTypes';

export interface ISpecificationsDetailsContainer {
  carSpecifications: GetCarSpecifications_carSpecifications[];
  loading: boolean;
}

const SpecificationsDetailsContainer: FunctionComponent<ISpecificationsDetailsContainer> = ({
  carSpecifications,
  loading,
}) => {
  if (!carSpecifications || loading) {
    return <SpecificationsAndFeaturesLoader />;
  }
  const featureGroups = specDataExtractor.getSpecPackByGroup(carSpecifications, SpecificationsTypes.FEATURES);
  const specGroups = specDataExtractor.getSpecPackByGroup(carSpecifications, SpecificationsTypes.SPECIFICATIONS);

  return (
    <>
      {specGroups && (
        <SpecificationsDetailList
          title={
            <Translation id="trans__configurator__customise_page_variant_section__specs_modal_specification_subtitle" />
          }
          variantFeatures={specGroups}
        />
      )}
      {featureGroups && (
        <SpecificationsDetailList
          title={<Translation id="trans__configurator__customise_page_variant_section__specs_features_subtitle" />}
          variantFeatures={featureGroups}
        />
      )}
    </>
  );
};

export default SpecificationsDetailsContainer;
